import React from 'react';
import PropTypes from 'prop-types';
import { formatPhoneNumber } from '../../../../helpers/genericFormator';

export default function PhoneNoFormatter(props) {
  const { data } = props;
  return data === '9999999999' ? (
    <div>---</div>
  ) : (
    <div>{`${data.mobile_extension || '+91'} ${data.mobile_number}`}</div>
  );
}
PhoneNoFormatter.propTypes = {
  row: PropTypes.object,
  data: PropTypes.string,
};
PhoneNoFormatter.defaultProps = {
  row: {},
  data: '',
};
